import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./dashboard.css";
import Logo from "../assets/Logos/Brewing-solutions-3.png";
import BackgroundImage from "../assets/green.webp";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';


const Login = () => {
    const navigate = useNavigate();
    const [inputUsername, setInputUsername] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    // const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);
  
      try {
        const response = await fetch("https://pints.beer/api/login.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: inputUsername,
            password: inputPassword,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          // Store token in local storage or state
          localStorage.setItem("token", data.token);
          toast.success('Login successful');
          // Redirect to dashboard
          navigate("/pints-dashboard");
       
        } else {
          // setShow(true);
          toast.error('Invalid username or password!');
        }
      } catch (error) {
        // console.error("Login failed:", error);
        // setShow(true);
        toast.error('Invalid username or password!');
      }
  
      setLoading(false);
    };
    return (
        <div
          className="sign-in__wrapper"
          style={{ backgroundImage: `url(${BackgroundImage})` }}
        >
          <ToastContainer/>
          {/* Overlay */}
          <div className="sign-in__backdrop"></div>
          {/* Form */}
          <Form className="shadow p-4 bg-black rounded" onSubmit={handleSubmit}>
            {/* Header */}
            <img
              className="mx-auto d-block mb-2"
              src={Logo}
              alt="logo"
            />
            {/* <div className="h4 mb-2">Sign In</div> */}
            {/* ALert */}
            
            <Form.Group className="mb-2" controlId="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                value={inputUsername}
                placeholder="Username"
                onChange={(e) => setInputUsername(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={inputPassword}
                placeholder="Password"
                onChange={(e) => setInputPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="checkbox">
              <Form.Check type="checkbox" label="Remember me" />
            </Form.Group>
            {!loading ? (
              <Button className="w-100" variant="primary" type="submit">
                Log In
              </Button>
            ) : (
              <Button className="w-100" variant="primary" type="submit" disabled>
                Logging In...
              </Button>
            )}

         
          </Form>
          {/* Footer */}
        
        </div>
      );
    };
    
    export default Login;